<template>
  <div
    v-if="!!mapWidgetGoogleApiKey"
    class="map-widget"
  >
    <a
      :href="`https://maps.google.com/?q=${mapWidgetLat},${mapWidgetLon}`"
      target="_blank"
      rel="noopener"
    >
      <img
        :alt="mapWidgetLocationName"
        :src="`${mapWidgetBaseURL}?markers=${params.markers}&zoom=${mapWidgetZoom}&size=${mapWidgetSize}&scale=${params.scale}&key=${mapWidgetGoogleApiKey}&style=${params.style}`"
      >
    </a>
  </div>
</template>

<script>
  export default {
    name: "KfMapWidget",
    props: {
      mapWidgetLocationName: {
        type: String,
        default: null,
      },
      mapWidgetLat: {
        type: String,
        default: null,
      },
      mapWidgetLon: {
        type: String,
        default: null,
      },
      mapWidgetBaseURL: {
        type: String,
        default: 'https://maps.googleapis.com/maps/api/staticmap'
      },
      mapWidgetGoogleApiKey: {
        type: String,
        default: "AIzaSyDxaR-YCqSgDFusWXxLgKOxwQck-QFDz_s",
      },
      mapWidgetSize: {
        type: String,
        default: '420x270',
      },
      mapWidgetZoom: {
        type: Number,
        default: 18,
      },
    },
    data() {
      return {
        params: {
          markers: `${this.mapWidgetLat},${this.mapWidgetLon}`,
          scale: 1,
          style: "feature:poi|visibility:off",
        },
      };
    },
  };

</script>

<style lang="postcss">
.map-widget {
  @apply rounded-smd overflow-hidden;
}
</style>
